import { create } from "zustand"

export const useAudioStore = create((set, get) => ({
  enabled: false,   
  master: 0,        

  setEnabled: (enabled) => set({ enabled }),
  setMaster: (master) => set({ master }),
}))
